<template>
    <div>
        <div v-if="editing" class="builder-randomizer flex-column">
            <div class="info">
                <h3>Builder Content Randomizer</h3>
                <p>Content added to the randomizer will be shown all at once while in the visual editor.</p>
                <p>View the builder.io preview to see how this will appear with randomized content when published.</p>
            </div>
            <div v-if="slotContent?.length == 0" class="no-content">
                <p>No Builder Content Found!</p>
            </div>
            <div v-else v-for="(content, i) of slotContent" :key="i" class="content-container">
                <div class="content-label">
                    <p>
                        <b>RANDOM {{ i+1 }}</b>
                    </p>
                </div>
                <component :is="content">

                </component>
            </div>
            <div class="content-drop">
                <p>Drop Randomizer Content Here</p>
            </div>
        </div>
        <component v-else :is="randomComponent">

        </component>
</div>
</template>
<script setup lang="ts">
    import { ref, computed, useSlots, onBeforeMount, useAttrs, onUnmounted  } from "vue";
    import { isEditing, isPreviewing } from "@builder.io/sdk-vue";
    import { useGenericStore } from "@/store/genericStore";
    import { storeToRefs } from "pinia";
    let editing = computed(() => {
        return isEditing();
    });

    const slots = useSlots();
    const slotContent:any[] = computed(()=>{
        return slots?.default?.()?.[0]?.children?.[0]?.children ?? [];
    })

    const randomComponent = ref(slotContent.value[0]);

    onBeforeMount(()=>{
        if(builderContent.value == null){
            builderContent.value = Math.floor(Math.random() * slotContent.value.length)
        }
        randomComponent.value = slotContent.value[builderContent.value]
    })
    

    let builderBlockId = computed(() => {
        let builderBlock = useAttrs().builderBlock

        return builderBlock?.id ?? Math.floor(Math.random() * 1000000);
    });

    let { state: builderContent } = storeToRefs(useGenericStore(`builderContent-${builderBlockId.value}`));

    
    builderContent.value = builderContent.value ?? Math.floor(Math.random() * slotContent.value.length)

    onUnmounted(()=>{
        builderContent.value = null;
    })
</script>
<style lang="scss" scoped>
    .builder-randomizer {
        .info {
            display: flex;
            flex-flow: column;
            margin-left: 0.5rem;
        }
        .no-content {
            display: flex;
            flex-flow: row;
            justify-content: center;
            align-items: center;
            height: 4rem;
        }
        .content-container {
            position: relative;
            .content-label {
                position: absolute; 
                width: fit-content; 
                top: 5%; 
                left: 2%; 
                z-index: 100;
                padding: 0.125rem 0.75rem;
                border-radius: 0.125rem;
                background-color: #f3f3f1;
            }
        }
        .content-drop {
            display:flex; 
            flex-flow: row; 
            justify-content: center; 
            align-items: center; 
            height: 6rem;

            border: 2px #c9c9c9 dashed;
        }
    }
</style>